// extracted by mini-css-extract-plugin
export default {"body":"DiscardFormDialog_body__J8XIq","removeFootprint":"DiscardFormDialog_removeFootprint__9obwq","content":"DiscardFormDialog_content__ZIfpG"};